import { Box, Button, CircularProgress, Container, Grid, IconButton, Modal, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow } from '@mui/material';
import React, { Component } from 'react'
import { Redirect } from 'react-router-dom';
import Constantes from '../php/Constantes';

const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const handleDownloadPdf = (name, data) => {
    const blobData = atob(data);
    const byteArray = new Uint8Array(blobData.length);
    for (let i = 0; i < blobData.length; i++) {
      byteArray[i] = blobData.charCodeAt(i);
    }
    const fileBlob = new Blob([byteArray], { type: 'application/pdf' });
    const fileUrl = URL.createObjectURL(fileBlob);

    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

let desc = '';
let entradaIn = '';
let salidaIn = '';

const opcionesFilasPorPagina = [5, 10, 25, 50, 100];
let filasTotales = 0;

class ConsultaSolicitudesFuncionarios extends Component {
    constructor(props){
        super(props);
        this.state = {

            //------------------
            pagina: 0,
            filasPorPagina: 5,
            //------------------

            loading: false,
            errores: null,
            notificaciones: null,
            consulta: {
                numeroFuncionario: '',
                nombreFuncionario: '',
                desde: '',
                mes: '',
                anio: '',
            },

            consultaRealizada: false,
            numeroNombre: [],
            datosConsulta: [],
            codigosInforme: [],
            horasEntradas: [],
            datoEspecifico: {},
            consultaEspecifica: false,
            imagenMostrarModal: false,
            imagenMostrar: '',
        }
        this.manejoEnvioConsulta = this.manejoEnvioConsulta.bind(this);
        this.manejarCambiosDatos = this.manejarCambiosDatos.bind(this);
        this.manejarAtrasCon = this.manejarAtrasCon.bind(this);
        this.manejarConsultaInforme = this.manejarConsultaInforme.bind(this);
        this.manejarAtrasEspecifica = this.manejarAtrasEspecifica.bind(this);
        this.manejarModalImagen = this.manejarModalImagen.bind(this);
        this.manejarCerrarModal = this.manejarCerrarModal.bind(this);
    }
    async componentDidMount(){
        const numNom = await fetch(`${Constantes.RUTA_API}/obtener_numerosNombre.php`);
        const datosNumNom = await numNom.json();
        this.setState({
            numeroNombre: datosNumNom,
        });

        const codInfo = await fetch(`${Constantes.RUTA_API}/obtener_codigosInformesPersonal.php`);
        const datosCodInfo = await codInfo.json();
        this.setState({
            codigosInforme: datosCodInfo,
        });

        const ent = await fetch(`${Constantes.RUTA_API}/obtener_entradas.php`);
        const datosEntrada = await ent.json();
        this.setState({
            horasEntradas: datosEntrada,
        });
    }
    render(){
        return (
            <>
                <Container>
                    <h3>Solicitudes Funcionarios</h3>
                    {this.state.loading
                    ?
                        <div style={{placeItems: 'center'}}>
                            <Box sx={{alignItems: 'center'}}>
                                <CircularProgress/>
                            </Box>
                        </div>
                    :
                        null
                    }
                    {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                    {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                    <br/>
                    {this.state.consultaRealizada
                    ?
                        null
                    :
                        <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                    <Table sx={{minWidth: 700}}>
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell>Numero Funcionario</StyledTableCell>
                                                <StyledTableCell>Nombre Funcionario</StyledTableCell>
                                                <StyledTableCell>Desde</StyledTableCell>
                                                <StyledTableCell>Mes</StyledTableCell>
                                                <StyledTableCell>Año</StyledTableCell>
                                                <StyledTableCell></StyledTableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            <StyledTableRow>
                                                <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='numeroFuncionario' value={this.state.consulta.numeroFuncionario} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                                <StyledTableCell>{this.state.consulta.nombreFuncionario}</StyledTableCell>
                                                <StyledTableCell><input min={'1000-01-01'} max={'9999-12-31'} style={{width:"100%", border:"2px solid #D6EAF8"}} type="date" id='desde' value={this.state.consulta.desde} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                                <StyledTableCell>
                                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='mes'  value={this.state.consulta.mes} onChange={this.manejarCambiosDatos}>
                                                        <option value=''>MES</option>
                                                        <option value={'01'}>ENERO</option>
                                                        <option value={'02'}>FEBRERO</option>
                                                        <option value={'03'}>MARZO</option>
                                                        <option value={'04'}>ABRIL</option>
                                                        <option value={'05'}>MAYO</option>
                                                        <option value={'06'}>JUNIO</option>
                                                        <option value={'07'}>JULIO</option>
                                                        <option value={'08'}>AGOSTO</option>
                                                        <option value={'09'}>SETIEMBRE</option>
                                                        <option value={'10'}>OCTUBRE</option>
                                                        <option value={'11'}>NOVIEMBRE</option>
                                                        <option value={'12'}>DICIEMBRE</option>
                                                    </select>
                                                </StyledTableCell>
                                                <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='anio' value={this.state.consulta.anio} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                                <StyledTableCell><button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejoEnvioConsulta()}>Consultar</button></StyledTableCell>
                                            </StyledTableRow>
                                        </TableBody>
                                    </Table>
                        </TableContainer>
                    }
                    {this.state.consultaRealizada && (!this.state.consultaEspecifica)
                    ?
                        <Container>
                            <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                <Table sx={{minWidth: 700}} id="tablaConsulta">
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell>Informe</StyledTableCell>
                                            <StyledTableCell>Estado</StyledTableCell>
                                            <StyledTableCell>Número Funcionario</StyledTableCell>
                                            <StyledTableCell>Nombre Funcionario</StyledTableCell>
                                            <StyledTableCell>Desde</StyledTableCell>
                                            <StyledTableCell>Hasta</StyledTableCell>
                                            <StyledTableCell></StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.state.datosConsulta.map((dato,index) => (
                                            <StyledTableRow key={index}>
                                                {this.state.codigosInforme.map((name2) => {
                                                    if(name2.idCodigosInformesPersonal === dato.codigo){
                                                        desc = name2.descripcion;
                                                    }
                                                })}
                                                <StyledTableCell>{desc}</StyledTableCell>
                                                <StyledTableCell>{dato.finalizado}</StyledTableCell>
                                                <StyledTableCell>{dato.numeroFuncionario}</StyledTableCell>
                                                <StyledTableCell>{dato.nombreFuncionario}</StyledTableCell>
                                                <StyledTableCell>{dato.desde}</StyledTableCell>
                                                <StyledTableCell>{dato.hasta}</StyledTableCell>
                                                <StyledTableCell><button className="btn btn-outline-success mx-2" type='button' onClick={() => this.manejarConsultaInforme(dato)}>Consultar</button></StyledTableCell>
                                            </StyledTableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <button className="btn btn-outline-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarAtrasCon}>Volver</button>
                        </Container>
                    :
                        null
                    }
                    {this.state.consultaEspecifica
                    ?
                        <Container>
                            <Box sx={{ flexGrow: 1}}>
                                <Grid container spacing={2} rowSpacing={1}>
                                    {this.state.codigosInforme.map((name2) => {
                                        if(name2.idCodigosInformesPersonal === this.state.datoEspecifico.codigo){
                                            desc = name2.descripcion;
                                        }
                                    })}
                                    <Grid item xs={4}>
                                    </Grid>
                                    <Grid item xs={4}>
                                        {desc}
                                    </Grid>
                                    <Grid item xs={4}>
                                    </Grid>
                                    {/*Esto va siempre */}
                                    <Grid item xs={2}>
                                    </Grid>
                                    {this.state.datoEspecifico.codigo === 3 || this.state.datoEspecifico.codigo === 4 || this.state.datoEspecifico.codigo === 42 || this.state.datoEspecifico.codigo === 43 || this.state.datoEspecifico.codigo === 77 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 19 || this.state.datoEspecifico.codigo === 21 || this.state.datoEspecifico.codigo === 44 || this.state.datoEspecifico.codigo === 51 || this.state.datoEspecifico.codigo === 22 || this.state.datoEspecifico.codigo === 23 || this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 47 || this.state.datoEspecifico.codigo === 48 || this.state.datoEspecifico.codigo === 56 || this.state.datoEspecifico.codigo === 66
                                    ?
                                        <Grid item xs={2}>
                                            <Item>Certificado (Imagen)</Item>
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 75
                                    ?
                                        <Grid item xs={2}>
                                            <Item>Comprobante (Imagen)</Item>
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 10
                                    ?
                                        <Grid item xs={2}>
                                            <Item>Constancia de Domicilio</Item>
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 75 || this.state.datoEspecifico.codigo === 10
                                    ?
                                        this.state.datoEspecifico.esPDF
                                        ?
                                            <Grid item xs={2}>
                                                <button className="btn btn-outline-primary mx-2" onClick={() => handleDownloadPdf('archivo.pdf', this.state.datoEspecifico.archivoBPS)}>Descargar</button>
                                            </Grid>
                                        :
                                            <Grid item xs={2}>
                                                <button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejarModalImagen(this.state.datoEspecifico.archivoBPS)}>Ver</button>
                                            </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 3 || this.state.datoEspecifico.codigo === 22 || this.state.datoEspecifico.codigo === 51 || this.state.datoEspecifico.codigo === 19 || this.state.datoEspecifico.codigo === 23 || this.state.datoEspecifico.codigo === 48 || this.state.datoEspecifico.codigo === 43 || this.state.datoEspecifico.codigo === 4 || this.state.datoEspecifico.codigo === 42 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13 || this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 47 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 56 || this.state.datoEspecifico.codigo === 77 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 66 || this.state.datoEspecifico.codigo === 21
                                    ?
                                        this.state.datoEspecifico.esPDF
                                        ?
                                            <Grid item xs={2}>
                                                <button className="btn btn-outline-primary mx-2" onClick={() => handleDownloadPdf('archivo.pdf', this.state.datoEspecifico.archivoBPS)}>Descargar</button>
                                            </Grid>
                                        :
                                            <Grid item xs={2}>
                                                <button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejarModalImagen(this.state.datoEspecifico.archivoBPS)}>Ver</button>
                                            </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 10 || this.state.datoEspecifico.codigo === 4 || this.state.datoEspecifico.codigo === 42 || this.state.datoEspecifico.codigo === 43 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 77 || this.state.datoEspecifico.codigo === 19 || this.state.datoEspecifico.codigo === 21 || this.state.datoEspecifico.codigo === 44 || this.state.datoEspecifico.codigo === 51 || this.state.datoEspecifico.codigo === 22 || this.state.datoEspecifico.codigo === 23 || this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 47 || this.state.datoEspecifico.codigo === 48 || this.state.datoEspecifico.codigo === 56 || this.state.datoEspecifico.codigo === 66
                                    ?
                                        <Grid item xs={1}>

                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13
                                    ?
                                        <Grid item xs={2}>
                                            <Item>Certificado De Parentesco (Imagen)</Item>
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13 || this.state.datoEspecifico.codigo === 11
                                    ?
                                        this.state.datoEspecifico.esPDF
                                        ?
                                            <Grid item xs={2}>
                                                <button className="btn btn-outline-primary mx-2" onClick={() => handleDownloadPdf('archivo.pdf', this.state.datoEspecifico.archivoActa)}>Descargar</button>
                                            </Grid>
                                        :
                                            <Grid item xs={2}>
                                                <button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejarModalImagen(this.state.datoEspecifico.archivoActa)}>Ver</button>
                                            </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13
                                    ?
                                        <Grid item xs={1}>

                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13
                                    ?
                                        <Grid item xs={2}>
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 4 || this.state.datoEspecifico.codigo === 42 || this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13
                                    ?
                                        <Grid item xs={2}>
                                            <Item>Familiar</Item>
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 42 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13 || this.state.datoEspecifico.codigo === 4
                                    ?
                                        <Grid item xs={2}>
                                            {this.state.datoEspecifico.familiar}
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 4 || this.state.datoEspecifico.codigo === 42 || this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13
                                    ?
                                        <Grid item xs={1}>

                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 4 || this.state.datoEspecifico.codigo === 42
                                    ?
                                        <Grid item xs={2}>

                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo !== 110 && this.state.datoEspecifico.codigo !== 75 && this.state.datoEspecifico.codigo !== 60
                                    ?
                                        <Grid item xs={2}>
                                            <Item>{this.state.datoEspecifico.codigo === 43 || this.state.datoEspecifico.codigo === 19 || this.state.datoEspecifico.codigo === 10 || this.state.datoEspecifico.codigo === 21 || this.state.datoEspecifico.codigo === 106 || this.state.datoEspecifico.codigo === 109 || this.state.datoEspecifico.codigo === 77 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 110 || this.state.datoEspecifico.codigo === 62 || this.state.datoEspecifico.codigo === 30 || this.state.datoEspecifico.codigo === 53 ? 'Día' : 'Desde'}</Item>
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo !== 110 && this.state.datoEspecifico.codigo !== 61 && this.state.datoEspecifico.codigo !== 75 && this.state.datoEspecifico.codigo !== 60
                                    ?
                                        <Grid item xs={2}>
                                            {this.state.datoEspecifico.desde}
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 61
                                    ?
                                        <Grid item xs={2}>
                                            {this.state.datoEspecifico.marca1}
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo !== 110 && this.state.datoEspecifico.codigo !== 60 && this.state.datoEspecifico.codigo !== 30
                                    ?
                                        <Grid item xs={1}>

                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 10
                                    ?
                                        <Grid item xs={2}>

                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 10
                                    ?
                                        <Grid item xs={2}>
                                            <Item>Nueva Dirección</Item>
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 10
                                    ?
                                        <Grid item xs={2}>
                                            {this.state.datoEspecifico.juzgado}
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 56 || this.state.datoEspecifico.codigo === 77
                                    ?
                                        <Grid item xs={2}>

                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 3 || this.state.datoEspecifico.codigo === 22 || this.state.datoEspecifico.codigo === 51 || this.state.datoEspecifico.codigo === 23 || this.state.datoEspecifico.codigo === 48 || this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 47 || this.state.datoEspecifico.codigo === 66 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13
                                    ?
                                        <Grid item xs={2}>
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo !== 53 && this.state.datoEspecifico.codigo !== 30 && this.state.datoEspecifico.codigo !== 60 && this.state.datoEspecifico.codigo !== 75 && this.state.datoEspecifico.codigo !== 62 && this.state.datoEspecifico.codigo !== 43 && this.state.datoEspecifico.codigo !== 19 && this.state.datoEspecifico.codigo !== 10 && this.state.datoEspecifico.codigo !== 21 && this.state.datoEspecifico.codigo !== 106 && this.state.datoEspecifico.codigo !== 109 && this.state.datoEspecifico.codigo !== 110 && this.state.datoEspecifico.codigo !== 37 && this.state.datoEspecifico.codigo !== 77
                                    ?
                                        <Grid item xs={2}>
                                            <Item>Hasta</Item>
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo !== 53 && this.state.datoEspecifico.codigo !== 30 && this.state.datoEspecifico.codigo !== 60 && this.state.datoEspecifico.codigo !== 75 && this.state.datoEspecifico.codigo !== 62 && this.state.datoEspecifico.codigo !== 61 && this.state.datoEspecifico.codigo !== 43 && this.state.datoEspecifico.codigo !== 19 && this.state.datoEspecifico.codigo !== 10 && this.state.datoEspecifico.codigo !== 21 && this.state.datoEspecifico.codigo !== 106 && this.state.datoEspecifico.codigo !== 109 && this.state.datoEspecifico.codigo !== 110 && this.state.datoEspecifico.codigo !== 37 && this.state.datoEspecifico.codigo !== 77
                                    ?
                                        <Grid item xs={2}>
                                            {this.state.datoEspecifico.hasta}
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 61
                                    ?
                                        <Grid item xs={2}>
                                            {this.state.datoEspecifico.marca2}
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo !== 53 && this.state.datoEspecifico.codigo !== 30 && this.state.datoEspecifico.codigo !== 60 && this.state.datoEspecifico.codigo !== 3 && this.state.datoEspecifico.codigo !== 43 && this.state.datoEspecifico.codigo !== 19 && this.state.datoEspecifico.codigo !== 10 && this.state.datoEspecifico.codigo !== 21 && this.state.datoEspecifico.codigo !== 106 && this.state.datoEspecifico.codigo !== 109 && this.state.datoEspecifico.codigo !== 110 && this.state.datoEspecifico.codigo !== 37 && this.state.datoEspecifico.codigo !== 77
                                    ?
                                    <Grid item xs={1}>

                                    </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 61
                                    ?
                                        <Grid item xs={2}>
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 61 || this.state.datoEspecifico.codigo === 60
                                    ?
                                        <Grid item xs={2}>
                                            <Item>Día</Item>
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 61 || this.state.datoEspecifico.codigo === 60
                                    ?
                                        <Grid item xs={2}>
                                            {this.state.datoEspecifico.desde}
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 80 || this.state.datoEspecifico.codigo === 71 || this.state.datoEspecifico.codigo === 1 || this.state.datoEspecifico.codigo === 67 || this.state.datoEspecifico.codigo === 40 || this.state.datoEspecifico.codigo === 16 || this.state.datoEspecifico.codigo === 17 || this.state.datoEspecifico.codigo === 29 || this.state.datoEspecifico.codigo === 5 || this.state.datoEspecifico.codigo === 52 || this.state.datoEspecifico.codigo === 14 || this.state.datoEspecifico.codigo === 15 || this.state.datoEspecifico.codigo === 20
                                    ?
                                        <Grid item xs={2}>
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo !== 53 && this.state.datoEspecifico.codigo !== 30 && this.state.datoEspecifico.codigo !== 60 && this.state.datoEspecifico.codigo !== 75 && this.state.datoEspecifico.codigo !== 62 && this.state.datoEspecifico.codigo !== 61 && this.state.datoEspecifico.codigo !== 4 && this.state.datoEspecifico.codigo !== 46 && this.state.datoEspecifico.codigo !== 28 && this.state.datoEspecifico.codigo !== 42 && this.state.datoEspecifico.codigo !== 43 && this.state.datoEspecifico.codigo !== 19 && this.state.datoEspecifico.codigo !== 10 && this.state.datoEspecifico.codigo !== 21 && this.state.datoEspecifico.codigo !== 44 && this.state.datoEspecifico.codigo !== 11 && this.state.datoEspecifico.codigo !== 12 && this.state.datoEspecifico.codigo !== 13 && this.state.datoEspecifico.codigo !== 106 && this.state.datoEspecifico.codigo !== 109 && this.state.datoEspecifico.codigo !== 110 && this.state.datoEspecifico.codigo !== 47 && this.state.datoEspecifico.codigo !== 66
                                    ?    
                                        <Grid item xs={2}>
                                            <Item>Días</Item>
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo !== 53 && this.state.datoEspecifico.codigo !== 30 && this.state.datoEspecifico.codigo !== 60 && this.state.datoEspecifico.codigo !== 75 && this.state.datoEspecifico.codigo !== 62 && this.state.datoEspecifico.codigo !== 61 && this.state.datoEspecifico.codigo !== 4 && this.state.datoEspecifico.codigo !== 46 && this.state.datoEspecifico.codigo !== 28 && this.state.datoEspecifico.codigo !== 42 && this.state.datoEspecifico.codigo !== 43 && this.state.datoEspecifico.codigo !== 19 && this.state.datoEspecifico.codigo !== 10 && this.state.datoEspecifico.codigo !== 21 && this.state.datoEspecifico.codigo !== 44 && this.state.datoEspecifico.codigo !== 11 && this.state.datoEspecifico.codigo !== 12 && this.state.datoEspecifico.codigo !== 13 && this.state.datoEspecifico.codigo !== 106 && this.state.datoEspecifico.codigo !== 109 && this.state.datoEspecifico.codigo !== 110 && this.state.datoEspecifico.codigo !== 47 && this.state.datoEspecifico.codigo !== 66
                                    ?  
                                        <Grid item xs={2}>
                                            {this.state.datoEspecifico.dias}
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 80 || this.state.datoEspecifico.codigo === 14 || this.state.datoEspecifico.codigo === 15 || this.state.datoEspecifico.codigo === 20 || this.state.datoEspecifico.codigo === 5 || this.state.datoEspecifico.codigo === 52
                                    ?
                                        <Grid item xs={1}>
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 5 || this.state.datoEspecifico.codigo === 52
                                    ?
                                        <Grid item xs={2}>
                                            <Item>Asignatura</Item>
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 5 || this.state.datoEspecifico.codigo === 52
                                    ?
                                        <Grid item xs={2}>
                                            {this.state.datoEspecifico.juzgado}
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 20
                                    ?
                                        <Grid item xs={2}>
                                            <Item>Documento</Item>
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 20
                                    ?
                                        <Grid item xs={2}>
                                            <button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejarModalImagen(this.state.datoEspecifico.archivoBPS)}>Ver</button>
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 14 || this.state.datoEspecifico.codigo === 15
                                    ?
                                        <Grid item xs={2}>
                                            <Item>Justificativo/Invitación</Item>
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 14 || this.state.datoEspecifico.codigo === 15
                                    ?
                                        <Grid item xs={2}>
                                            <button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejarModalImagen(this.state.datoEspecifico.archivoBPS)}>Ver</button>
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 14 || this.state.datoEspecifico.codigo === 15
                                    ?
                                        <Grid item xs={1}>
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 14 || this.state.datoEspecifico.codigo === 15
                                    ?
                                        <Grid item xs={2}>
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 14 || this.state.datoEspecifico.codigo === 15
                                    ?
                                        <Grid item xs={2}>
                                            <Item>Motivo</Item>
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 14 || this.state.datoEspecifico.codigo === 15
                                    ?
                                        <Grid item xs={2}>
                                            {this.state.datoEspecifico.juzgado}
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 14 || this.state.datoEspecifico.codigo === 15
                                    ?
                                        <Grid item xs={1}>
                                        </Grid>
                                    :
                                        null
                                    }
                                    {(this.state.datoEspecifico.codigo === 71) || (this.state.datoEspecifico.codigo === 1) || (this.state.datoEspecifico.codigo === 67) || (this.state.datoEspecifico.codigo === 2) || (this.state.datoEspecifico.codigo === 77) || (this.state.datoEspecifico.codigo === 37) || (this.state.datoEspecifico.codigo === 40) || (this.state.datoEspecifico.codigo === 35) || (this.state.datoEspecifico.codigo === 56) || (this.state.datoEspecifico.codigo === 14) || (this.state.datoEspecifico.codigo === 15) || (this.state.datoEspecifico.codigo === 16) || (this.state.datoEspecifico.codigo === 17) || (this.state.datoEspecifico.codigo === 20)
                                    ?  
                                        <Grid item xs={1}>
                                            
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.horasEntradas.map((name) => {
                                        if(this.state.datoEspecifico.entrada === name.idEntrada){
                                            entradaIn = name.descripcion;
                                    }})}
                                    {this.state.horasEntradas.map((name) => {
                                        if(this.state.datoEspecifico.salida === name.idEntrada){
                                            salidaIn = name.descripcion;
                                    }})}
                                    {this.state.datoEspecifico.codigo === 71
                                    ?
                                        <Grid item xs={2}>
                                            <Item>Entrada</Item>
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 71
                                    ?
                                        <Grid item xs={2}>
                                            {entradaIn}
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 71
                                    ?
                                        <Grid item xs={1}>
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 71
                                    ?
                                        <Grid item xs={2}>
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 71
                                    ?
                                        <Grid item xs={2}>
                                            <Item>Salida</Item>
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 71
                                    ?
                                        <Grid item xs={2}>
                                            {salidaIn}
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 71
                                    ?
                                        <Grid item xs={1}>
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo !== 53 && this.state.datoEspecifico.codigo !== 30 && this.state.datoEspecifico.codigo !== 60 && this.state.datoEspecifico.codigo !== 3 && this.state.datoEspecifico.codigo !== 75 && this.state.datoEspecifico.codigo !== 62 && this.state.datoEspecifico.codigo !== 71 && this.state.datoEspecifico.codigo !== 61 && this.state.datoEspecifico.codigo !== 14 && this.state.datoEspecifico.codigo !== 16 && this.state.datoEspecifico.codigo !== 17 && this.state.datoEspecifico.codigo !== 15 && this.state.datoEspecifico.codigo !== 4 && this.state.datoEspecifico.codigo !== 29 && this.state.datoEspecifico.codigo !== 46 && this.state.datoEspecifico.codigo !== 28 && this.state.datoEspecifico.codigo !== 42 && this.state.datoEspecifico.codigo !== 43 && this.state.datoEspecifico.codigo !== 77 && this.state.datoEspecifico.codigo !== 37 && this.state.datoEspecifico.codigo !== 19 && this.state.datoEspecifico.codigo !== 10 && this.state.datoEspecifico.codigo !== 21 && this.state.datoEspecifico.codigo !== 44 && this.state.datoEspecifico.codigo !== 51 && this.state.datoEspecifico.codigo !== 22 && this.state.datoEspecifico.codigo !== 23 && this.state.datoEspecifico.codigo !== 20 && this.state.datoEspecifico.codigo !== 57 && this.state.datoEspecifico.codigo !== 11 && this.state.datoEspecifico.codigo !== 12 && this.state.datoEspecifico.codigo !== 13 && this.state.datoEspecifico.codigo !== 35 && this.state.datoEspecifico.codigo !== 106 && this.state.datoEspecifico.codigo !== 107 && this.state.datoEspecifico.codigo !== 109 && this.state.datoEspecifico.codigo !== 108 && this.state.datoEspecifico.codigo !== 5 && this.state.datoEspecifico.codigo !== 52 && this.state.datoEspecifico.codigo !== 110 && this.state.datoEspecifico.codigo !== 47 && this.state.datoEspecifico.codigo !== 48 && this.state.datoEspecifico.codigo !== 56 && this.state.datoEspecifico.codigo !== 66
                                    ?    
                                        <Grid item xs={2}>
                                            <Item>Ejercicio (AÑO)</Item>
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo !== 53 && this.state.datoEspecifico.codigo !== 30 && this.state.datoEspecifico.codigo !== 60 && this.state.datoEspecifico.codigo !== 3 && this.state.datoEspecifico.codigo !== 75 && this.state.datoEspecifico.codigo !== 62 && this.state.datoEspecifico.codigo !== 71 && this.state.datoEspecifico.codigo !== 61 && this.state.datoEspecifico.codigo !== 14 && this.state.datoEspecifico.codigo !== 16 && this.state.datoEspecifico.codigo !== 17 && this.state.datoEspecifico.codigo !== 15 && this.state.datoEspecifico.codigo !== 4 && this.state.datoEspecifico.codigo !== 29 && this.state.datoEspecifico.codigo !== 46 && this.state.datoEspecifico.codigo !== 28 && this.state.datoEspecifico.codigo !== 42 && this.state.datoEspecifico.codigo !== 43 && this.state.datoEspecifico.codigo !== 77 && this.state.datoEspecifico.codigo !== 37 && this.state.datoEspecifico.codigo !== 19 && this.state.datoEspecifico.codigo !== 10 && this.state.datoEspecifico.codigo !== 21 && this.state.datoEspecifico.codigo !== 44 && this.state.datoEspecifico.codigo !== 51 && this.state.datoEspecifico.codigo !== 22 && this.state.datoEspecifico.codigo !== 23 && this.state.datoEspecifico.codigo !== 20 && this.state.datoEspecifico.codigo !== 57 && this.state.datoEspecifico.codigo !== 11 && this.state.datoEspecifico.codigo !== 12 && this.state.datoEspecifico.codigo !== 13 && this.state.datoEspecifico.codigo !== 35 && this.state.datoEspecifico.codigo !== 106 && this.state.datoEspecifico.codigo !== 107 && this.state.datoEspecifico.codigo !== 109 && this.state.datoEspecifico.codigo !== 108 && this.state.datoEspecifico.codigo !== 5 && this.state.datoEspecifico.codigo !== 52 && this.state.datoEspecifico.codigo !== 110 && this.state.datoEspecifico.codigo !== 47 && this.state.datoEspecifico.codigo !== 48 && this.state.datoEspecifico.codigo !== 56 && this.state.datoEspecifico.codigo !== 66
                                    ?  
                                        <Grid item xs={2}>
                                            {this.state.datoEspecifico.anio}
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 2 && this.state.datoEspecifico.codigo !== 106 && this.state.datoEspecifico.codigo !== 109
                                    ?  
                                        <Grid item xs={1}>
                                            
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 28 || this.state.datoEspecifico.codigo === 46
                                    ?
                                        <Grid item xs={2}>

                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 30 || this.state.datoEspecifico.codigo === 60 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 77 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 106 || this.state.datoEspecifico.codigo === 109 || this.state.datoEspecifico.codigo === 28 || this.state.datoEspecifico.codigo === 46 || this.state.datoEspecifico.codigo === 110
                                    ?    
                                        <Grid item xs={2}>
                                            <Item>Minutos</Item>
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 30 || this.state.datoEspecifico.codigo === 60 || this.state.datoEspecifico.codigo === 110 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 77 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 106 || this.state.datoEspecifico.codigo === 109 || this.state.datoEspecifico.codigo === 28 || this.state.datoEspecifico.codigo === 46
                                    ?  
                                        <Grid item xs={2}>
                                            {this.state.datoEspecifico.minutos}
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 30 || this.state.datoEspecifico.codigo === 60 || this.state.datoEspecifico.codigo === 110 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 77 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 28 || this.state.datoEspecifico.codigo === 46
                                    ?  
                                        <Grid item xs={1}>
                                            
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 35
                                    ?    
                                        <Grid item xs={2}>
                                            <Item>Juzgado</Item>
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 35
                                    ?  
                                        <Grid item xs={2}>
                                            {this.state.datoEspecifico.juzgado}
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 106 || this.state.datoEspecifico.codigo === 109
                                    ?  
                                        <Grid item xs={1}>
                                            
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 30 || this.state.datoEspecifico.codigo === 60 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 77
                                    ?
                                        <Grid item xs={2}>

                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 30 || this.state.datoEspecifico.codigo === 60 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 77 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 28 || this.state.datoEspecifico.codigo === 46
                                    ?    
                                        <Grid item xs={2}>
                                            <Item>Tipo Salida</Item>
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 30 || this.state.datoEspecifico.codigo === 60 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 28 || this.state.datoEspecifico.codigo === 46 || this.state.datoEspecifico.codigo === 37
                                    ?  
                                        <Grid item xs={2}>
                                            {this.state.datoEspecifico.tipo}
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 77
                                    ?  
                                        <Grid item xs={2}>
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 28 || this.state.datoEspecifico.codigo === 46
                                    ?  
                                        <Grid item xs={1}>
                                            
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 106
                                    ?    
                                        <Grid item xs={2.1}>
                                            <Item>Entrada</Item>
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 106
                                    ?  
                                        <Grid item xs={2}>
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 106
                                    ?  
                                        <Grid item xs={1}>
                                            
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 106
                                    ?    
                                        <Grid item xs={2.1}>
                                            <Item>Salilda</Item>
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 106
                                    ?  
                                        <Grid item xs={2}>
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 106
                                    ?  
                                        <Grid item xs={1}>
                                            
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 106
                                    ?    
                                        <Grid item xs={2.1}>
                                            <Item>Entrada</Item>
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 106
                                    ?  
                                        <Grid item xs={2}>
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 106 || this.state.datoEspecifico.codigo === 109
                                    ?  
                                        <Grid item xs={1}>
                                            
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 109
                                    ?
                                        <Grid item xs={2.1}>
                                            <Item>Concepto</Item>
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 109
                                    ?
                                        <Grid item xs={2.1}>
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 106
                                    ?    
                                        <Grid item xs={2.1}>
                                            <Item>Salilda</Item>
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 106
                                    ?  
                                        <Grid item xs={2}>
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 106 || this.state.datoEspecifico.codigo === 109
                                    ?  
                                        <Grid item xs={1}>
                                            
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 110
                                    ?
                                        <Grid item xs={2}>
                                            <Item>Día</Item>
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 110
                                    ?
                                        <Grid item xs={2}>
                                            {this.state.datoEspecifico.desde}
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 110
                                    ?
                                        <Grid item xs={1}>

                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 62
                                    ?
                                        <Grid item xs={2}>
                                            <Item>Tipo Omisión</Item>
                                        </Grid>
                                    :
                                        null
                                    }
                                    {this.state.datoEspecifico.codigo === 62
                                    ?
                                        <Grid item xs={2}>
                                            {this.state.datoEspecifico.tipo}
                                        </Grid>
                                    :
                                        null
                                    }
                                </Grid>
                            </Box>
                            {this.state.datoEspecifico.codigo === 110
                            ?
                                <br/>
                            :
                                null
                            }
                            <br/>
                            {this.state.datoEspecifico.codigo === 110 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 77 || this.state.datoEspecifico.codigo === 60 ? <textarea style={{width:"100%", border:"2px solid #D6EAF8"}} rows={5} cols={20} id='comentarios' value={this.state.datoEspecifico.comentarios} disabled/> : null}
                            {this.state.datoEspecifico.motivoRechazo !== null && this.state.datoEspecifico.motivoRechazo !== '' ? <textarea style={{width:"100%", border:"2px solid #D6EAF8"}} rows={10} cols={40} id='motivoRechazo' value={this.state.datoEspecifico.motivoRechazo} disabled/> : null}
                            <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarAtrasEspecifica}>Volver</button>
                        </Container>
                    :
                        null
                    }
                    {this.state.imagenMostrarModal
                    ?
                        <Modal open={this.state.imagenMostrarModal}>
                            <Box sx={styleModal} >
                                <Grid container spacing={2} rowSpacing={1}>
                                    <img src={this.state.imagenMostrar} alt="" style={{ width: '90%'}}/>
                                    <Grid item xs={5}>
                                        
                                    </Grid>
                                    <Grid item xs={2}>
                                        <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarCerrarModal}>Cerrar</button>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Modal>
                    :
                        null
                    }
                </Container>
            </>
        )
    }

    async manejoEnvioConsulta(){
        this.setState({
            errores: null,
            notificaciones: null,
            loading: false,
            consultaRealizada: false,
        })
        if((this.state.consulta.numeroFuncionario !== '') && (this.state.consulta.nombreFuncionario === '')){
            this.setState({
                errores: 'Debe ingresar un número de funcionario valido',
            })
        }else if((this.state.consulta.mes !== '') && (this.state.consulta.anio === '')){
            this.setState({
                errores: 'Debe ingresar el año de la consulta',
            })
        }else{
            this.setState({
                loading: true,
                errores: null,
                notificaciones: null,
            })
            const cargaUtil = JSON.stringify([this.state.consulta, sessionStorage.lugar, sessionStorage.lugarCentral, sessionStorage.numeroFuncionarioAsociado]);
            const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_solicitudesFuncionarios.php`,{
                method: 'POST',
                body: cargaUtil,
            })

            const exito = await respuesta.json();

            this.setState({
                errores: exito[0],
                loading: false,
            })
            if(exito[0] === 'ok'){
                this.setState({
                    errores: null,
                    notificaciones: null,
                    datosConsulta: exito[1],
                    consultaRealizada: true,
                })
            }

        }
    }

    manejarCambiosDatos(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState({
            errores: null,
            notificaciones: null,
            consultaRealizada: false,
            datosConsulta: [],
        });
        this.setState(state => {
            const numFunActualizado = state.consulta;
            numFunActualizado[clave] = valor;
            
            if((clave === 'numeroFuncionario') && (valor !== '') ){
                //valor = parseFloat(valor);
                //Tengo que buscar la informacion de ese funcionario
                let aux = true;
                this.state.numeroNombre.map((name) =>
                {if(name.numeroFuncionario === valor){
                    numFunActualizado['nombreFuncionario'] = name.primerNombre + ' ' + name.primerApellido;
                    aux = false;
                }else if(aux){
                    numFunActualizado['nombreFuncionario'] = '';
                }
                });
            }else if((clave === 'nombreFuncionario') && (valor === '')){
                numFunActualizado['nombreFuncionario'] = '';
            }
            
            return{
                consulta: numFunActualizado,
            };
        });
    }

    manejarAtrasCon(e){
        e.preventDefault();
        this.setState({
            datosConsulta: [],
            consultaRealizada: false,
            errores: null,
            notificaciones: null,
        })
    }

    manejarConsultaInforme(dato){
        this.setState({
            datoEspecifico: dato,
            consultaEspecifica: true,
        })
    }

    manejarAtrasEspecifica(e){
        e.preventDefault();
        this.setState({
            consultaEspecifica: false,
            datoEspecifico: {},
        })
    }

    manejarModalImagen(dato){
        this.setState({
            imagenMostrarModal: true,
            imagenMostrar: dato,
        })
    }

    manejarCerrarModal(e){
        e.preventDefault();
        this.setState({
            imagenMostrarModal: false,
            imagenMostrar: '',
        })
    }
}

export default ConsultaSolicitudesFuncionarios